<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <div class="d-flex justify-content-between">
            <h6 class="element-header">
              {{ $t('region.title') }}
            </h6>

            <CreateButton
                :label="$t('region.create')"
                :to="{ name: 'regionForm' }">
            </CreateButton>
          </div>

          <div class="element-box">
            <h5 class="form-header mb-4">
              {{ $t('region.list') }}
            </h5>

            <div class="table-responsive overflow-auto pt-4">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th>
                    <span>Name</span>
                  </th>
                  <th style=" text-align: right; padding-right: 30px; min-width: 150px;">
                    <a href="#">{{ $t('general.actions') }}</a>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(region) in regions.data" :key="region.id">
                  <td>
                    {{ region?.name }}
                  </td>
                  <td class="text-end">
                    <button class="btn btn-primary"
                            @click="router.push({name: 'regionForm', params: {id: region?.id} })">
                      <i class="os-icon os-icon-edit"></i>
                    </button>
                    <button class="btn btn-danger ms-2"
                            @click="deleteModal(region?.id)">
                      <i class="os-icon os-icon-trash"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>

      <Sidebar></Sidebar>
    </div>
  </div>

  <ModalDelete
      @update:modelValue="updateModal"
      :modelValue="showModal"
      :header="t('general.delete_item_header')"
      :onDelete="deleteRegion">
  </ModalDelete>
</template>


<script setup>
import regionService from '@/api/Region';
import CreateButton from '@/components/CreateButton.vue';
import Sidebar from '@/components/FormSidebar.vue';
import ModalDelete from '@/components/modal/ModalDelete.vue';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import router from '@/router';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t }       = useI18n();
const regions     = ref([]);
const showModal   = ref(false);
const regionId    = ref(0);
const isSearching = ref(false);

async function getRegions() {
  CloseToast();
  isSearching.value = true;

  try {
    const { data }    = await regionService.getRegions();
    regions.value     = data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

async function deleteRegion() {
  try {
    await regionService.deleteRegion(regionId.value);
    showModal.value = false;
    await getRegions();
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

function updateModal(value) {
  CloseToast();
  showModal.value = value;
}

function deleteModal(id) {
  CloseToast();
  regionId.value  = id;
  showModal.value = true;
}

onMounted(async() => {
   await  getRegions();
});

</script>

<style scoped>

</style>